// extracted by mini-css-extract-plugin
module.exports = {"ether":"ether_ether__MD3Ca","image":"ether_image__Y3ESR","btn":"ether_btn__4pdvT","time":"ether_time__F27Mk","title":"ether_title__y5QbH","section":"ether_section__xEibb"};